<template>
    <a class="scroll-to-top-btn" :class="{ visible: showSrocllToTop }" @click.prevent="srocllToTop()">
        <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </a>
</template>

<script>
  import Velocity from 'velocity-animate';

  export default {
    name: 'ScrollToTop',
    data() {
      return {
        showSrocllToTop: false,
      };
    },
    mounted() {
      window.addEventListener('scroll', () => {
        this.showSrocllToTop = window.pageYOffset > 300;
      });
    },
    methods: {
      srocllToTop() {
        Velocity(
          document.getElementsByTagName('html')[0],
          {
            scrollTop: 0,
          },
          {
            offset: 0,
            duration: 500,
            easing: 'easeOutExpo',
            mobileHA: false,
          },
        );
      },
    },
  };
</script>

<style lang="scss">
    @import "../styles/helpers/variables";
    .scroll-to-top-btn {
        display: block;
        position: fixed;
        right: 16px;
        bottom: -($btn-height * 2);
        width: $btn-height;
        height: $btn-height;
        transition: bottom 400ms cubic-bezier(.68, -.55, .265, 1.55), opacity .3s, background-color .3s, border-color .3s;
        border-radius: 50%;
        background-color: rgba($black-color, .3);
        color: $white-color !important;
        font-size: $font-size-lead;
        line-height: ($btn-height - 5);
        opacity: 0;
        z-index: 2000;
        text: {
            align: center;
            decoration: none;
        }
        cursor: pointer;
        &:hover {
            background-color: rgba($black-color, .8);
            color: $white-color;
        }
        &:focus, &:active { color: $white-color; }
        &.visible {
            bottom: 14px;
            opacity: 1;
        }
        @media (max-width: $screen-md) {
            bottom: ($btn-sm-height * 3) !important;
            width: $btn-sm-height;
            height: $btn-sm-height;
            line-height: ($btn-sm-height - 5);
        }
    }
</style>
